/* ============================================================
   FRAISE NOIRE — FICHE PRODUIT (comportements)

   Portage de js/produit.js (V2) MOINS tout ce qui reconstruisait la page.
   La V2 fabriquait la fiche entiere en JavaScript a partir de ?handle= ;
   charge tel quel sur Shopify, ce script ecrasait le HTML de Liquid et
   affichait « Piece introuvable » sur CHAQUE produit. Ici le HTML vient de
   sections/produit.liquid, et il ne reste que les comportements :

     1. barre d'achat collante (apparition, tailles, ajout)
     2. guide des tailles (ouverture / fermeture)
     3. « Cela se porte avec » — moteur a 3 etages, repris a l'identique
     4. toast partage, utilise aussi par fn-panier.js pour exiger une taille

   Le choix de la taille reste porte par les radios de la grille principale :
   deux etats de selection concurrents finiraient par se contredire, et le
   client verrait une taille entouree differente de celle envoyee au panier.
   ============================================================ */
(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const racine = $('[data-pdp]');
  if (!racine) return;

  const form = $('#form-produit');
  const atc = $('.pdp__atc');
  const grille = $('.pdp__sizegrid');

  /* ---------- LA PHOTO SUIT LE COLORIS ----------
     Choisir « Rose » doit MONTRER la rose : jusqu'ici la fiche ne changeait que
     le nom et le prix, la photo restait celle du premier coloris (signale par
     Hedy le 2026-10-07).

     On ne deplace rien dans le DOM et on ne cache aucune vue : la galerie est
     une colonne sur ordinateur et un carrousel sur telephone, alors on change
     seulement l'ORDRE d'affichage (flex `order`) et on ramene le carrousel au
     debut. La vue choisie passe en tete, les autres restent juste derriere.

     Deux fiches differentes mènent ici — celle a plusieurs options (JSON
     `data-variantes`) et celle a option unique (radios `data-media`) — d'ou
     une seule fonction, branchee aux deux. */
  const galerie = $('.pdp__gallery');
  const vues = galerie ? $$('.pdp__shot[data-media]', galerie) : [];
  function poserPhoto(idMedia) {
    if (!galerie || vues.length < 2 || !idMedia) return;
    const cible = vues.find(f => f.dataset.media === String(idMedia));
    if (!cible || cible.style.order === '-1') return;          // deja en tete
    /* Les vues autres que la premiere sont en chargement differe : amenees en
       tete, elles s'affichaient VIDES — le navigateur ne les avait jamais
       demandees. On force la cible AVANT de la deplacer. */
    const img = cible.querySelector('img');
    if (img) {
      img.loading = 'eager';
      if (!img.complete) img.src = img.src;                    // relance la requete
    }
    vues.forEach(f => { f.style.order = f === cible ? '-1' : '0'; });
    if (galerie.scrollWidth > galerie.clientWidth + 1) {
      galerie.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }
  /* ---------- LE CHOIX ARRIVE PAR L'ADRESSE ----------
     Un lien « ?variant=... » doit ouvrir la fiche SUR ce choix. Sans cela, on
     cliquait « Rose » dans le rayon et la fiche s'ouvrait sur l'orange, coloris
     non coche : le client devait le re-choisir (defaut vu le 2026-10-07).
     Cela sert aussi aux liens du panier et a tout lien partage. */
  (function choixDepuisAdresse() {
    const id = new URLSearchParams(location.search).get('variant');
    if (!id) return;
    const radio = document.querySelector(`input[data-variant="${CSS.escape(id)}"]`);
    if (!radio || radio.disabled || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));   // prix, bouton, photo
  })();

  /* Fiche a option unique : chaque radio porte la photo de sa variante. */
  if (vues.length > 1) {
    const radios = $$('input[data-variant][data-media]');
    if (radios.length) {
      document.addEventListener('change', e => {
        const r = e.target.closest && e.target.closest('input[data-variant][data-media]');
        if (r) poserPhoto(r.dataset.media);
      });
      const coche = radios.find(r => r.checked);
      if (coche) poserPhoto(coche.dataset.media);
    }
  }

  /* ---------- 1. toast (expose, voir fn-panier.js) ---------- */
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#16161A" stroke-width="2">'
      + '<path d="M12 8v5M12 16.5v.5"/><circle cx="12" cy="12" r="9"/></svg><span></span>';
    el.querySelector('span').textContent = msg;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('show'));
    clearTimeout(toast._t);
    toast._t = setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => { el.hidden = true; }, 280);
    }, 2200);
  }
  window.FN_TOAST = toast;

  /* ---------- 1 bis. CHOIX A DEUX OPTIONS ----------
     Cinq pieces se declinent en couleur ET en taille (jusqu'a quarante
     combinaisons). Une grille unique y affichait « S M L XL XXL » huit fois de
     suite : autant de boutons identiques, aucun moyen de designer sa couleur.
     Ici, une grille par option, et le couple choisi resout la variante.
     Les combinaisons qui n'existent pas, ou qui sont epuisees, sont grisees au
     fur et a mesure — on ne laisse pas le client choisir ce qu'on ne peut pas
     lui envoyer. */
  const balise = document.querySelector('[data-variantes]');
  if (balise && form) {
    let VAR = [];
    try { VAR = JSON.parse(balise.textContent); } catch (_) { VAR = []; }
    const grilles = $$('.pdp__sizegrid[data-option]', form);
    const champ = form.querySelector('[data-variant-id]');
    const prix = document.querySelector('[data-prix]');
    const bouton = form.querySelector('[name="add"]');

    const choisies = () => grilles.map(g => {
      const coche = g.parentElement.querySelector('input:checked');
      return coche ? coche.dataset.valeur : null;
    });

    const trouver = vals => VAR.find(v => vals.every((x, i) => x !== null && v.o[i] === x));
    const montrerPhoto = v => poserPhoto(v && v.img);

    function rafraichir() {
      const vals = choisies();

      /* Disponibilite croisee : pour chaque grille, une valeur reste
         proposable s'il existe au moins une variante en stock qui la porte,
         compte tenu de ce qui est deja choisi dans les AUTRES grilles. */
      grilles.forEach((g, gi) => {
        $$('input[data-valeur]', g.parentElement).forEach(radio => {
          const essai = vals.slice();
          essai[gi] = radio.dataset.valeur;
          const possible = VAR.some(v => v.dispo && essai.every((x, i) => i === gi ? v.o[i] === essai[i] : (x === null || v.o[i] === x)));
          radio.disabled = !possible;
          const etiquette = g.querySelector(`label[for="${radio.id}"]`);
          if (etiquette) {
            etiquette.classList.toggle('pdp__size--out', !possible);
            etiquette.classList.toggle('is-sel', radio.checked);
          }
        });
      });

      const v = trouver(vals);
      if (champ) champ.value = v ? v.id : '';
      montrerPhoto(v);
      /* `innerHTML` et non `textContent` : le prix vient du gabarit de la
         boutique et contient une espace insecable ecrite en entite. Dans un
         <script type="application/json">, les entites ne sont PAS decodees —
         `textContent` affichait donc « 59,99&nbsp;€ » en toutes lettres. La
         chaine ne provient d'aucune saisie : seulement de notre snippet prix. */
      if (v && prix && v.prix) prix.innerHTML = v.prix;
      if (bouton) {
        const complet = vals.every(x => x !== null);
        bouton.disabled = complet && (!v || !v.dispo);
        bouton.textContent = complet && (!v || !v.dispo) ? 'Indisponible' : 'Ajouter au panier';
      }
    }

    form.addEventListener('change', e => {
      if (e.target.matches('input[data-valeur]')) rafraichir();
    });
    rafraichir();

    /* Le champ cache part vide tant que le couple n'est pas complet : c'est ce
       qui empeche d'envoyer au panier une piece dont la couleur n'a pas ete
       choisie. fn-panier.js refuse alors l'envoi et le dit. */
  }

  /* ---------- 2. barre collante ---------- */
  const barre = $('[data-sticky]');
  if (barre && atc) {
    /* Les mini-boutons cochent la vraie radio et declenchent `change` :
       fn-panier.js met alors a jour le champ cache, le marquage et le prix.
       Sans ce declenchement, le panier recevrait la taille precedente. */
    $$('[data-sticky-sizes] [data-pour]').forEach(b => {
      b.addEventListener('click', () => {
        const radio = document.getElementById(b.dataset.pour);
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Miroir du marquage : la grille principale est la source. */
    const refletBarre = () => {
      const choisi = $('.pdp__sizegrid .pdp__size.is-sel');
      const pour = choisi ? choisi.getAttribute('for') : null;
      $$('[data-sticky-sizes] [data-pour]').forEach(b =>
        b.classList.toggle('is-sel', !!pour && b.dataset.pour === pour));
      const prix = $('[data-prix]'), pb = $('[data-sticky-price]');
      if (prix && pb) pb.textContent = prix.textContent;
    };
    if (form) form.addEventListener('change', refletBarre);

    const ajout = $('[data-sticky-add]');
    /* On passe par le formulaire : un seul chemin d'ajout, donc un seul
       endroit ou la taille est exigee et ou l'erreur est affichee. */
    if (ajout && form) {
      ajout.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    /* Apparition quand le bouton principal est sorti par le haut.

       Un IntersectionObserver ne previent qu'aux CHANGEMENTS d'etat : si le
       bouton passe de « sous l'ecran » a « au-dessus de l'ecran » sans jamais
       y entrer — ce que fait un coup de pouce rapide sur telephone —, aucune
       transition n'a lieu et la barre ne sortait jamais. On regarde donc la
       position reelle, a chaque image, et seulement quand ca defile. */
    let enAttente = false;
    const majBarre = () => {
      enAttente = false;
      barre.hidden = atc.getBoundingClientRect().bottom > 80;
    };
    const demander = () => {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(majBarre);
    };
    addEventListener('scroll', demander, { passive: true });
    addEventListener('resize', demander, { passive: true });
    majBarre();
  }

  /* ---------- 3. guide des tailles ---------- */
  const guide = $('[data-size-guide]');
  if (guide) {
    const ouvrir = () => { guide.hidden = false; requestAnimationFrame(() => guide.classList.add('show')); };
    const fermer = () => { guide.classList.remove('show'); setTimeout(() => { guide.hidden = true; }, 300); };
    document.addEventListener('click', e => {
      if (e.target.closest('[data-size-open]')) { e.preventDefault(); ouvrir(); }
      else if (e.target.closest('[data-size-close]')) fermer();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !guide.hidden) fermer();
    });
  }

  /* ---------- 4. « Cela se porte avec » ----------
     Moteur a trois etages de la V2, inchange :
       1. familles de design reelles du catalogue (meme motif sur plusieurs pieces)
       2. regles de complementarite par categorie (jamais un hoodie en 1er pour un short)
       3. tie-break seuil 80 € : la piece qui fait franchir la livraison offerte passe en 1er
     Rotation deterministe par handle (seed) : chaque fiche montre des pieces
     differentes, et toujours les memes pour un meme produit. */
  const FN = window.FN;
  const handle = racine.dataset.handle || '';
  const grilleRel = $('[data-related]');
  const blocRel = $('[data-related-wrap]');

  if (FN && FN.PRODUCTS && handle && grilleRel && blocRel) {
    const p = FN.PRODUCTS.find(x => x.handle === handle);
    if (p) {
      const FAMILIES = [
        ['t-shirt-fraise-doodle-fraise-noire-2023', 'ensemble-t-shirt-short-doodle-noir', 'ensemble-t-shirt-short-doodle-citron-vert', 'ensemble-t-shirt-short-doodle-bleu-petrole', 'ensemble-t-shirt-short-doodle-rouge-fraise'],
        ['t-shirt-rats-des-villes-fraise-noire-2023', 'hoodies-design-a-capuche-fraisier-vert-copie'],
        ['t-shirt-manches-courtes-99-white', 'hoodies-design-a-capuche-99japon'],
        ['t-shirt-the-ruche-blanc', 't-shirt-the-ruche-bleu-ciel', 'casquette-abeille-orange', 'casquette-abeille-bleue'],
        ['survetement-pink-design', 'hoodies-design-a-capuche-fraisier-noir-copie'],
        ['casquette-fraise-gold', 'casquette-fraise-gold-hologramme', 'casquette-fraise-hologramme'],
        ['casquette-ajustable-style-trucker-fraise-noire-2023', 't-shirt-summer-2085-fraise-noire-2023'],
      ];
      const RULES = {
        't-shirt': ['Casquettes', 'Shorts', 'Hoodies'],
        'Shorts': ['t-shirt', 'Casquettes'],
        'Hoodies': ['Casquettes', 't-shirt'],
        'Casquettes': ['t-shirt', 'Shorts', 'Hoodies'],
        'Ensembles': ['Casquettes', 't-shirt'],
        'Survêtements': ['Casquettes', 't-shirt'],
      };

      const seed = [...p.handle].reduce((s, ch) => s + ch.charCodeAt(0), 0);
      const vendable = x => x && x.handle !== p.handle && x.available && x.img;
      const retenus = [], vus = new Set([p.handle]);
      const prendre = x => { if (x && !vus.has(x.handle)) { retenus.push(x); vus.add(x.handle); } };

      const fam = FAMILIES.find(f => f.includes(p.handle)) || [];
      fam.filter(h => h !== p.handle)
         .map(h => FN.PRODUCTS.find(x => x.handle === h))
         .filter(vendable)
         .slice(0, 2)
         .forEach(prendre);

      const cats = RULES[p.cat] || ['Casquettes', 't-shirt', 'Hoodies'];
      for (let pass = 0; pass < 4 && retenus.length < 4; pass++) {
        for (const c of cats) {
          if (retenus.length >= 4) break;
          const cands = FN.PRODUCTS.filter(x => vendable(x) && FN.matchCat(x, c) && !vus.has(x.handle));
          if (cands.length) prendre(cands[(seed + pass) % cands.length]);
        }
      }
      if (retenus.length < 4) {
        FN.PRODUCTS.filter(x => vendable(x) && !vus.has(x.handle))
          .slice(0, 4 - retenus.length).forEach(prendre);
      }
      if (p.price < 80) {
        const i = retenus.findIndex(x => x.price + p.price >= 80);
        if (i > 0) retenus.unshift(retenus.splice(i, 1)[0]);
      }

      if (retenus.length) {
        grilleRel.innerHTML = retenus.slice(0, 4).map(FN.card).join('');
        blocRel.hidden = false;
      }
    }
  }
})();
